<div class="flex flex-col">
  <!-- Action Icon Buttons -->
  <mx-action-buttons>
    @let hasLinkedCatalogRecord = selectors.hasLinkedCatalogRecordFor(itemRequest) | select:false;
    @if (isClosed) {
      <px-hold-icon-button [catalogRecordId]="hasLinkedCatalogRecord ? itemRequest.linkedCatalogRecord.id : 0" [visible]="hasLinkedCatalogRecord"/>
    } @else {
      <mx-icon-button icon="close" tooltip="Cancel Request" (click)="cancelRequestClicked()"/>
    }

    <!-- View Details Button -->
    <mx-icon-button icon="comment" tooltip="View Details" color="on-surface-variant" [matBadge]="badgeFor(itemRequest) | select" matBadgeSize="small"
                    (click)="viewDetailsClicked()" class="mat-badge-error"/>
  </mx-action-buttons>

  <!-- Status -->
  <mat-chip-set>
    <mx-status-chip [status]="selectors.statusFor(itemRequest) | select" [colors]="chipColors" [displayableStatusNames]="chipNames"/>
  </mat-chip-set>
</div>
